var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"preco"}},[_c('Banner',{attrs:{"contents":_vm.banner}}),_c('PrecoDoDia'),_c('PrecoRevista')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }